import {
    ConfigsInfo,
    ContactInfo,
    ContactTypeInfo,
    PriceComission,
    contactInfoDefault,
    priceComissionDefault,
} from '../context/configs_context'
import { get, post, put } from './generic'

export interface ContactTypeApiData {
    id_tipo_contato: number
    nome: string
}

export interface ContactApiData {
    id_contato: number
    valor: string
    id_tipo_contato: number
    id_configs: number
    tipoContato: ContactTypeApiData
}

export interface PriceComissionApiData {
    id_comissao_preco: number
    id_configs: number
    nome: string
    comissao: string
    porc_lucro: number
}

export interface ConfigsApiData {
    id_configs: number
    fuso_horario: number
    fuso_horario_pais: string
    flag_horario_verao: number
    metodo_venda: number
    nome_empresa: string | null
    logo_empresa: string | null
    slogan_empresa: string | null
    documento_empresa: string | null
    digito_inicial_balanca: number
    qnt_digitos_cod_barra_balanca: number
    qnt_digitos_balanca: number
    digito_final_balanca: number
    tipo_balanca: number
    flag_sistema_filial: number
    flag_usar_senha_mestre: number
    regime_empresa: string
    cod_departamento_emissao_empresa: string
    desc_departamento_emissao_empresa: string
    cod_cidade_emissao_empresa: string
    desc_cidade_emissao_empresa: string
    cod_atividade_economica_empresa: string
    desc_atividade_economica_empresa: string
    num_casa_emissao_empresa: string
    cod_distrito_emissao_empresa: string
    desc_distrito_emissao_empresa: string
    flag_fatura_eletronica: number
    certificado_publico_fatura: string | null
    chave_privada_fatura: string | null
    codigo_secreto_fatura: string | null
    codigo_identificador_fatura: string | null
    data_fatura: string | null
    flag_metodo_impressao: number
    tamanho_fonte_ticket: number
    flag_tipo_buscador: number
    flag_impressao_venda: number
    flag_impressao_venda_pendente: number
    ordem_itens_impressao_venda: number
    flag_impressao_caixa: number
    flag_impressao_pagamento: number
    flag_fatura_apos_venda: number
    flag_fatura_apos_finalizar_venda: number
    flag_exibir_contado: number
    posicoes_fatura_impressa: string | null
    posicoes_etiqueta_produto: string | null
    quantidade_notas_fatura: number
    flag_imprimir_meia_folha: number
    flag_exibir_codigo_fatura: number
    flag_exibir_codigo_barras_fatura: number
    flag_exibir_estoque_filiais: number
    flag_exibir_codigo: number
    flag_esconder_total_letras: number
    flag_tela_pagamento: number
    flag_esconder_pagare: number
    flag_logo_ticket: number
    flag_gasto_pendiente: number
    decimais_quantidade: number
    flag_faturacao_cliente_anonimo: number
    flag_pix_habilitado: number
    tipo_chave_pix: string | null
    chave_pix: string | null
    flag_formato_ticket: number
    flag_exibir_moeda_secundaria_ticket: number
    flag_formato_ticket_produto: number
    flag_escolher_metodo_pagamento: number
    flag_escolher_caixa: number
    flag_alterar_compra: number
    flag_acrescentar_iva: number
    flag_descontar_caixa_padrao: number
    flag_manter_valores_caixa: number
    flag_exibir_nome_filial_nota: number
    numero_linhas_paginacao: number
    flag_preco_cif_editavel: number
    linguagem: string
    flag_ignorar_limite_caracteres_nota: number
    webhook_url: string | null
    webhook_username: string | null
    webhook_password: string | null
    flag_exibir_ncm_fatura: number
    flag_permitir_codigo_duplicado: number
    flag_usar_senha_mestre_vender_abaixo_preco_unitario: number
    flag_usar_senha_mestre_limite_excedido: number
    flag_tipo_calculo_lucro: number
    flag_codigo_interno_incremental: number
    preco_minimo_usar_senha_mestre: string
    preco_minimo_usar_senha_mestre_autopreco: string
    flag_exibir_serial_entrega: number
    flag_exibir_lote_entrega: number
    flag_bloquear_autopreco_abaixo_preco_venda: number
    quantidade_tickets: number
    flag_busca_localizacao: number
    fonte_matricial: string
    quantidade_notas_entrega: number
    quantidade_notas_orcamento: number
    flag_troco_caixa: number
    flag_transferir_estoque_negativo: number;
    limite_produtos_venda: number;
    cores_sidebar: string | null;
    flag_exibir_peso_venda: number;
    flag_remover_juros_recibo: number;
    flag_esconder_lista_precos_venda: number;
    flag_exibir_lista_precos_tabela: number;
    email_autovalor: string;
    telefone_autovalor: string;
    flag_exibir_stock_venda: number;
    flag_exibir_peso_fatura: number;
    flag_exibir_observacao_fatura: number;
    flag_controle_produto_pre_venda: number;
    flag_exibir_imagem_venda: number;
    flag_exibir_pagare_orcamento: number;
    flag_exibir_preco_unitario_fatura: number;
    flag_exibir_porcentagem_desconto_fatura: number;
    flag_exibir_observacao_lista_venda: number;
    flag_exibir_imagem_fatura: number;
    flag_permitir_nota_credito_nota_comum: number;
    observacao_nota_comum: string | null;
    observacao_orcamento: string | null;
    flag_exibir_stock_compra: number;
    flag_validar_ip: number;
    ips_validos: string | null;
    flag_devolver_produtos_entregues: number;
    flag_modificar_preco_venda_tela_compra: number;
    telefone_whatsapp: string | null;
    flag_confirmacao_whatsapp: number;
    contatos: ContactApiData[]
    comissoesPreco: PriceComissionApiData[]
}

interface UpdateConfigsInterface {
    fuso_horario: number
    fuso_horario_pais: string
    flag_horario_verao: number
    metodo_venda: number
    senha_mestre?: string | null
    nome_empresa: string | null
    logo_empresa: string | null
    slogan_empresa: string | null
    documento_empresa: string | null
    digito_inicial_balanca: number
    qnt_digitos_cod_barra_balanca: number
    qnt_digitos_balanca: number
    digito_final_balanca: number
    tipo_balanca: number
    flag_usar_senha_mestre: number
    regime_empresa: string
    cod_departamento_emissao_empresa: string
    desc_departamento_emissao_empresa: string
    cod_cidade_emissao_empresa: string
    desc_cidade_emissao_empresa: string
    cod_atividade_economica_empresa: string
    desc_atividade_economica_empresa: string
    num_casa_emissao_empresa: string
    cod_distrito_emissao_empresa: string
    desc_distrito_emissao_empresa: string
    flag_fatura_eletronica: number
    certificado_publico_fatura: string | null
    chave_privada_fatura: string | null
    codigo_secreto_fatura: string | null
    codigo_identificador_fatura: string | null
    data_fatura: string | null
    flag_metodo_impressao: number
    tamanho_fonte_ticket: number
    flag_tipo_buscador: number
    flag_impressao_venda: number
    flag_impressao_venda_pendente: number
    ordem_itens_impressao_venda: number
    flag_impressao_caixa: number
    flag_impressao_pagamento: number
    flag_fatura_apos_venda: number
    flag_fatura_apos_finalizar_venda: number
    flag_exibir_contado: number
    posicoes_fatura_impressa: string | null
    posicoes_etiqueta_produto: string | null
    quantidade_notas_fatura: number
    flag_imprimir_meia_folha: number
    flag_exibir_codigo_fatura: number
    flag_exibir_codigo_barras_fatura: number
    flag_exibir_estoque_filiais: number
    flag_exibir_codigo: number
    flag_esconder_total_letras: number
    flag_tela_pagamento: number
    flag_esconder_pagare: number
    decimais_quantidade: number
    flag_logo_ticket: number
    flag_gasto_pendiente: number
    flag_faturacao_cliente_anonimo: number
    flag_pix_habilitado: number
    tipo_chave_pix: string | null
    chave_pix: string | null
    flag_formato_ticket: number
    flag_exibir_moeda_secundaria_ticket: number
    flag_formato_ticket_produto: number
    flag_escolher_metodo_pagamento: number
    flag_escolher_caixa: number
    flag_alterar_compra: number
    flag_acrescentar_iva: number
    flag_descontar_caixa_padrao: number
    flag_manter_valores_caixa: number
    flag_exibir_nome_filial_nota: number
    numero_linhas_paginacao: number
    flag_preco_cif_editavel: number
    linguagem: string
    flag_ignorar_limite_caracteres_nota: number
    webhook_url: string | null
    webhook_username: string | null
    webhook_password: string | null
    flag_exibir_ncm_fatura: number
    flag_permitir_codigo_duplicado: number
    flag_usar_senha_mestre_vender_abaixo_preco_unitario: number
    flag_usar_senha_mestre_limite_excedido: number
    flag_tipo_calculo_lucro: number
    flag_codigo_interno_incremental: number
    preco_minimo_usar_senha_mestre: string
    preco_minimo_usar_senha_mestre_autopreco: string
    flag_exibir_serial_entrega: number
    flag_exibir_lote_entrega: number
    flag_bloquear_autopreco_abaixo_preco_venda: number
    quantidade_tickets: number
    flag_busca_localizacao: number
    fonte_matricial: string
    quantidade_notas_entrega: number
    quantidade_notas_orcamento: number
    flag_troco_caixa: number
    flag_transferir_estoque_negativo: number;
    limite_produtos_venda: number;
    cores_sidebar: string | null;
    flag_exibir_peso_venda: number;
    flag_remover_juros_recibo: number;
    flag_esconder_lista_precos_venda: number;
    flag_exibir_lista_precos_tabela: number;
    email_autovalor: string;
    telefone_autovalor: string;
    flag_exibir_stock_venda: number;
    flag_exibir_peso_fatura: number;
    flag_exibir_observacao_fatura: number;
    flag_controle_produto_pre_venda: number;
    flag_exibir_imagem_venda: number;
    flag_exibir_pagare_orcamento: number;
    flag_exibir_preco_unitario_fatura: number;
    flag_exibir_porcentagem_desconto_fatura: number;
    flag_exibir_observacao_lista_venda: number;
    flag_exibir_imagem_fatura: number;
    flag_permitir_nota_credito_nota_comum: number;
    observacao_nota_comum: string | null;
    observacao_orcamento: string | null;
    flag_exibir_stock_compra: number;
    flag_validar_ip: number;
    ips_validos: string | null;
    flag_devolver_produtos_entregues: number;
    flag_modificar_preco_venda_tela_compra: number;
    telefone_whatsapp: string | null;
    flag_confirmacao_whatsapp: number;
    contatos: {
        valor: string
        id_tipo_contato: number
    }[]
    comissoesPreco: {
        nome: string
        comissao: number
        porc_lucro: number
    }[]
}

export function parseContactType(data: ContactTypeApiData): ContactTypeInfo {
    return {
        id: data.id_tipo_contato,
        name: data.nome,
    }
}

export function parseConctact(data: ContactApiData): ContactInfo {
    return {
        id: data.id_contato,
        value: data.valor,
        contactType: data.tipoContato
            ? parseContactType(data.tipoContato)
            : data.tipoContato,
        contactTypeId: data.id_tipo_contato,
    }
}

export function parsePriceComission(
    data: PriceComissionApiData
): PriceComission {
    return {
        id: data.id_comissao_preco,
        name: data.nome,
        comission: Number(data.comissao) * 100,
        porcentGain: Number(data.porc_lucro),
    }
}

export function parseConfigs(data: ConfigsApiData): ConfigsInfo {
    return {
        id: data.id_configs,
        timeZone: data.fuso_horario,
        timeZoneCountry: data.fuso_horario_pais,
        isSummerTime: Boolean(data.flag_horario_verao),
        masterPassword: '',
        saleMethod: data.metodo_venda,
        companyName: data.nome_empresa,
        companyLogo: data.logo_empresa
            ? {
                  content: data.logo_empresa,
                  file: new File([], data.logo_empresa),
                  isBase64: false,
              }
            : null,
        companySlogan: data.slogan_empresa,
        companyDocument: data.documento_empresa,
        balance: {
            initialDigit: data.digito_inicial_balanca,
            barcodeLength: data.qnt_digitos_cod_barra_balanca,
            balanceLength: data.qnt_digitos_balanca,
            finalDigit: data.digito_final_balanca,
            balanceType: data.tipo_balanca,
        },
        systemBranch: data.flag_sistema_filial,
        useMasterPassword: Boolean(data.flag_usar_senha_mestre),
        companyRegime: data.regime_empresa,
        companyEmissionDepartmentId: data.cod_departamento_emissao_empresa,
        companyEmissionDepartmentDescription:
            data.desc_departamento_emissao_empresa,
        companyEmissionCityId: data.cod_cidade_emissao_empresa,
        companyEmissionCityDescription: data.desc_cidade_emissao_empresa,
        companyEconomicActivityId: data.cod_atividade_economica_empresa,
        companyEconomicActivityDescription:
            data.desc_atividade_economica_empresa,
        companyEmissionHouseNumber: data.num_casa_emissao_empresa,
        companyEmissionDistrictId: data.cod_distrito_emissao_empresa,
        companyEmissionDistrictDescription: data.desc_distrito_emissao_empresa,
        useElectronicNote: data.flag_fatura_eletronica,
        publicCertificateEletronicNote: data.certificado_publico_fatura ?? '',
        privateKeyEletronicNote: data.chave_privada_fatura ?? '',
        secretCodeEletronicNote: data.codigo_secreto_fatura ?? '',
        identifierEletronicNote: data.codigo_identificador_fatura ?? '',
        dateEletronicNote: data.data_fatura ? new Date(data.data_fatura) : null,
        printMethod: data.flag_metodo_impressao,
        ticketFontSize: data.tamanho_fonte_ticket,
        searchType: data.flag_tipo_buscador,
        salePrintMethod: data.flag_impressao_venda,
        salePrintMethodPending: data.flag_impressao_venda_pendente,
        itemPrintOrderSale: data.ordem_itens_impressao_venda,
        cashierPrintMethod: data.flag_impressao_caixa,
        paymentPrintMethod: data.flag_impressao_pagamento,
        noteAfterSale: Boolean(data.flag_fatura_apos_venda),
        noteAfterFinalizeSale: Boolean(data.flag_fatura_apos_finalizar_venda),
        showOnlyNormalPaymentType: Boolean(data.flag_exibir_contado),
        printPosition: data.posicoes_fatura_impressa,
        productBarcodePrintPosition: data.posicoes_etiqueta_produto,
        notesQnt: data.quantidade_notas_fatura,
        printHalfPage: Boolean(data.flag_imprimir_meia_folha),
        showIdOnNote: Boolean(data.flag_exibir_codigo_fatura),
        showBarcodeOnNote: Boolean(data.flag_exibir_codigo_barras_fatura),
        showBranchStock: Boolean(data.flag_exibir_estoque_filiais),
        showId: data.flag_exibir_codigo,
        hideWrittenTotal: Boolean(data.flag_esconder_total_letras),
        paymentScreen: data.flag_tela_pagamento,
        promissoryNoteMode: data.flag_esconder_pagare,
        useLogoInTicket: Boolean(data.flag_logo_ticket),
        flagGastoPendiente: Boolean(data.flag_gasto_pendiente),
        qntDecimals: data.decimais_quantidade,
        billAnonymousClient: Boolean(data.flag_faturacao_cliente_anonimo),
        isPixActivated: Boolean(data.flag_pix_habilitado),
        pixKeyType: data.tipo_chave_pix,
        pixKey: data.chave_pix,
        ticketType: data.flag_formato_ticket,
        showSecondaryCoinTotalsTicket: Boolean(
            data.flag_exibir_moeda_secundaria_ticket
        ),
        productTicketType: data.flag_formato_ticket_produto,
        needToChoosePaymentMethod: Boolean(data.flag_escolher_metodo_pagamento),
        chooseCashier: Boolean(data.flag_escolher_caixa),
        changeInBuy: data.flag_alterar_compra,
        incrementIva: Boolean(data.flag_acrescentar_iva),
        discountCashierDefault: Boolean(data.flag_descontar_caixa_padrao),
        keepCashierValues: Boolean(data.flag_manter_valores_caixa),
        showBranchNameInNote: Boolean(data.flag_exibir_nome_filial_nota),
        paginationRowsNumber: data.numero_linhas_paginacao,
        isCifPriceEditable: Boolean(data.flag_preco_cif_editavel),
        language: data.linguagem,
        ignoreCharacterLimitNote: Boolean(
            data.flag_ignorar_limite_caracteres_nota
        ),
        webhookUrl: data.webhook_url,
        webhookUsername: data.webhook_username,
        webhookPassword: data.webhook_password,
        showNcmOnNote: Boolean(data.flag_exibir_ncm_fatura),
        allowDuplicatedCode: Boolean(data.flag_permitir_codigo_duplicado),
        useMasterPasswordWhenSellLowerThanUnitPrice: Boolean(
            data.flag_usar_senha_mestre_vender_abaixo_preco_unitario
        ),
        useMasterPasswordWhenClientLimitExceeds: Boolean(data.flag_usar_senha_mestre_limite_excedido),
        gainCalculationType: data.flag_tipo_calculo_lucro,
        isInternalCodeIncremental: Boolean(
            data.flag_codigo_interno_incremental
        ),
        contacts: data.contatos.length
            ? data.contatos.map(parseConctact)
            : [{ ...contactInfoDefault }],
        priceComission: data.comissoesPreco.length
            ? data.comissoesPreco.map(parsePriceComission)
            : [{ ...priceComissionDefault }],
        masterPasswordMinPrice: data.preco_minimo_usar_senha_mestre,
        masterPasswordMinPriceAutoprice:
            data.preco_minimo_usar_senha_mestre_autopreco,
        showSerialInDelivery: Boolean(data.flag_exibir_serial_entrega),
        showLoteInDelivery: Boolean(data.flag_exibir_lote_entrega),
        blockSellLowerThanSalePriceAutoprice: Boolean(
            data.flag_bloquear_autopreco_abaixo_preco_venda
        ),
        ticketsQnt: data.quantidade_tickets,
        searchByLocalization: Boolean(data.flag_busca_localizacao),
        matrixFont: data.fonte_matricial,
        deliveryNotesQnt: data.quantidade_notas_entrega,
        budgetNotesQnt: data.quantidade_notas_orcamento,
        includeChangeInCashier: Boolean(data.flag_troco_caixa),
        canTransferNegativeStock: Boolean(data.flag_transferir_estoque_negativo),
        productLimitInSale: data.limite_produtos_venda,
        layoutConfigs: data.cores_sidebar,
        showWeightInSale: Boolean(data.flag_exibir_peso_venda),
        removeFeesFromReceipt: Boolean(data.flag_remover_juros_recibo),
        hidePriceListInSale: Boolean(data.flag_esconder_lista_precos_venda),
        showPriceListInTable: Boolean(data.flag_exibir_lista_precos_tabela),
        emailAutovalue: data.email_autovalor,
        phoneAutovalue: data.telefone_autovalor,
        showStockOnSale: Boolean(data.flag_exibir_stock_venda),
        showWeightOnNote: Boolean(data.flag_exibir_peso_fatura),
        showObservationOnNote: Boolean(data.flag_exibir_observacao_fatura),
        controlProductsInPreSale: Boolean(data.flag_controle_produto_pre_venda),
        showImageOnSale: Boolean(data.flag_exibir_imagem_venda),
        showContractOnBudget: Boolean(data.flag_exibir_pagare_orcamento),
        showUnitPriceOnNote: Boolean(data.flag_exibir_preco_unitario_fatura),
        showDiscountPercentageOnNote: Boolean(
            data.flag_exibir_porcentagem_desconto_fatura
        ),
        showObservationOnSaleList: Boolean(
            data.flag_exibir_observacao_lista_venda
        ),
        showImageOnNote: Boolean(data.flag_exibir_imagem_fatura),
        allowCreditNoteForCommonNote: Boolean(data.flag_permitir_nota_credito_nota_comum),
        observationCommonNote: data.observacao_nota_comum,
        observationBudget: data.observacao_orcamento,
        showStockOnBuy: Boolean(data.flag_exibir_stock_compra),
        validateIp: Boolean(data.flag_validar_ip),
        validIps: data.ips_validos ?? '',
        refundDeliveredProducts: Boolean(data.flag_devolver_produtos_entregues),
        modifySalePriceInBuyScreen: Boolean(data.flag_modificar_preco_venda_tela_compra),
        whatsappPhone: data.telefone_whatsapp ?? '',
        whatsappConfirmationEnabled: Boolean(data.flag_confirmacao_whatsapp),
    }
}

export async function getConfigs(): Promise<ConfigsInfo> {
    const res = await get('configs')
    return parseConfigs(res.data.data.configs)
}

export async function updateConfigs(
    data: UpdateConfigsInterface
): Promise<void> {
    await put('configs', data, {
        useRecaptcha: true,
    })
}

export async function listContactTypes(): Promise<ContactTypeInfo[]> {
    const res = await get('contact-type')
    return res.data.data.map(parseContactType)
}

let whatsappValidatedAt = 0

export function markWhatsappValidated() {
    whatsappValidatedAt = Date.now()
}

export async function validateMasterPassword(senha: string): Promise<void> {
    if (
        whatsappValidatedAt &&
        Date.now() - whatsappValidatedAt < 2 * 60 * 1000
    ) {
        whatsappValidatedAt = 0
        return
    }

    await post('configs/validate-master-password', {
        senha: senha,
    })
}

export type WhatsappConfirmationAction =
    | 'remove_product'
    | 'below_min_price'
    | 'generic'

export interface WhatsappConfirmationContext {
    action: WhatsappConfirmationAction
    user?: string
    product?: string
    price?: string
    minPrice?: string
}

export async function sendMasterPasswordWhatsapp(
    context?: WhatsappConfirmationContext
): Promise<{
    token: string
}> {
    const res = await post('configs/master-password/whatsapp/send', {
        context,
    })
    return res.data.data
}

export async function getMasterPasswordWhatsappStatus(
    token: string
): Promise<{ confirmed: boolean; expired: boolean }> {
    const res = await post('configs/master-password/whatsapp/status', {
        token,
    })
    return res.data.data
}
